import { lazyWithRetry } from "../utils/lazyWithRetry";
import ClientLayout   from "../layouts/ClientLayout";
import Home           from "../pages/client/home/Home";

// Everything below is code-split into its own chunk and only downloaded
// when a visitor actually navigates to it - the homepage no longer has to
// load the JS for booking, facility pages, the blog, etc. up front.
const Booking             = lazyWithRetry(() => import("../pages/client/Booking"));
const BookingVerify       = lazyWithRetry(() => import("../pages/client/BookingVerify"));
const UploadPayment       = lazyWithRetry(() => import("../pages/client/UploadPayment"));
const FacilityPage        = lazyWithRetry(() => import("../pages/client/facilities/FacilityPage"));
const About               = lazyWithRetry(() => import("../pages/client/about/About"));
const Contact             = lazyWithRetry(() => import("../pages/client/contact/Contact"));
const Gallery             = lazyWithRetry(() => import("../pages/client/gallery/Gallery"));
const Experience          = lazyWithRetry(() => import("../pages/client/blog/Experience"));
const TermsAndConditions  = lazyWithRetry(() => import("../pages/client/legal/TermsAndConditions"));
const PrivacyPolicy       = lazyWithRetry(() => import("../pages/client/legal/PrivacyPolicy"));
const RefundPolicy        = lazyWithRetry(() => import("../pages/client/legal/RefundPolicy"));

const clientRoutes = {
  element: <ClientLayout />,
  children: [
    { index: true,                  element: <Home /> },
    { path: "booking",              element: <Booking /> },
    { path: "bookingverify",        element: <BookingVerify /> },
    { path: "uploadpayment",        element: <UploadPayment /> },
    { path: "facilities/:facilityId", element: <FacilityPage /> },
    { path: "about",                element: <About /> },
    { path: "contact",              element: <Contact /> },
    { path: "gallery",              element: <Gallery /> },
    { path: "blog",                 element: <Experience /> },
    { path: "terms",                element: <TermsAndConditions /> },
    { path: "privacy",              element: <PrivacyPolicy /> },
    { path: "refund",               element: <RefundPolicy /> }
  ],
};

export default clientRoutes;